import { render, staticRenderFns } from "./aboutUs.vue?vue&type=template&id=38041a40&scoped=true"
import script from "./aboutUs.vue?vue&type=script&lang=js"
export * from "./aboutUs.vue?vue&type=script&lang=js"
import style0 from "./aboutUs.vue?vue&type=style&index=0&id=38041a40&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38041a40",
  null
  
)

export default component.exports